import { type VariantProps, tv } from 'tailwind-variants';

const block = tv({
  base: 'w-full animate-pulse rounded-xl transition-all',
  variants: {
    variant: {
      square: 'aspect-square',
      accordion: 'h-[44px]',
      preview: 'aspect-117/100',
    },
    color: {
      gray: 'bg-gray-15 dark:bg-gray-75',
      white: 'dark:bg-gray-90 bg-white',
    },
  },
  defaultVariants: {
    variant: 'square',
    color: 'gray',
  },
});

export default function LoadingBlock({
  className = '',
  variant,
  color,
}: {
  className?: string;
  variant?: VariantProps<typeof block>['variant'];
  color?: VariantProps<typeof block>['color'];
}) {
  return <div className={block({ variant, className, color })} />;
}
